/**
 * Ulazna tačka CRA aplikacije: ResizeObserver patch, axe-core (dev), React root mount.
 */

import './boot/resizeObserverPatch';
import React from 'react';
import ReactDOM from 'react-dom/client';
// Učitaj Font Awesome ikonice
import '@fortawesome/fontawesome-free/css/all.css';
import './index.css';
import '@/shared/styles/tiptap-link-icons.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// PDF.js / viewer библиотеке често изазову узорак где ResizeObserver у истом фрејму покрене поновно прерачунавање —
// прегледнице тада бацају ову поруку; то није баг апликације, па је не приказујемо кроз dev overlay.
if (typeof window !== 'undefined') {
  const resizeObserverHarmlessMsg = /^ResizeObserver loop/;
  const isResizeObserverNoise = (event) => {
    const fromEvent = typeof event?.message === 'string' ? event.message : '';
    const fromError = typeof event?.error?.message === 'string' ? event.error.message : '';
    return (
      resizeObserverHarmlessMsg.test(fromEvent) || resizeObserverHarmlessMsg.test(fromError)
    );
  };
  window.addEventListener(
    'error',
    (event) => {
      if (!isResizeObserverNoise(event)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}

// Accessibility testing u development-u
// Učitaj axe-core samo ako je feature flag eksplicitno omogućen
// Ako flag nije postavljen ili je false, preskoči učitavanje
const enableA11Y = process.env.REACT_APP_ENABLE_A11Y_CHECK === 'true';
if (enableA11Y && process.env.NODE_ENV === 'development') {
  // Dinamički import sa error handling-om
  // Koristimo requestIdleCallback da izbegnemo blokiranje main thread-a
  // Fallback na requestAnimationFrame ako requestIdleCallback nije dostupan
  const loadAxe = () => {
    // Koristimo requestIdleCallback sa većim timeout-om da izbegnemo violation
    // ili requestAnimationFrame za bolje performanse
    const initAxe = () => {
      import('@axe-core/react')
        .then((axe) => {
          if (axe && axe.default) {
            // Smanjujemo delay sa 1000ms na 500ms da smanjimo violation
            axe.default(React, ReactDOM, 500);
          }
        })
        .catch((error) => {
          // Ignoriši greške pri učitavanju axe-core
          // Ovo je samo za accessibility testing i nije kritično za funkcionalnost aplikacije
        });
    };

    // Koristimo requestAnimationFrame umesto direktnog poziva da izbegnemo violation
    requestAnimationFrame(() => {
      requestAnimationFrame(initAxe);
    });
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(loadAxe, { timeout: 3000 });
  } else {
    // Fallback za browsere koji ne podržavaju requestIdleCallback
    requestAnimationFrame(() => {
      requestAnimationFrame(loadAxe);
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

